const state = {
    audienceDetailName: '',
    searchPanelCache: null,
    SearchPanelActiveFlagCache: false,
    SearchToggleCache: null,
    SearchResultTableCache: null,
    SearchResultTableStateCache: null,
};
const getters = {
    audienceDetailName(state) {
        const name = state.audienceDetailName;
        // resets to black the audienceDetailName because it should only be used once.
        // When user first lands on details page we use the audiene name from this store so that there is no delay.
        state.audienceDetailName = '';
        return name;
    },
    searchPanelCache(state) { return state.searchPanelCache; },
    SearchPanelActiveFlagCache(state) { return state.SearchPanelActiveFlagCache; },
    SearchToggleCache(state) { return state.SearchToggleCache; },
    SearchResultTableCache(state) { return state.SearchResultTableCache; },
    SearchResultTableStateCache(state) { return state.SearchResultTableStateCache; }
};
const actions = {
    setAudienceDetailName({ commit }, data) {
        commit('setAudienceDetailName', data);
    },
    setSearchPanelCache({ commit }, data) {
        commit('setSearchPanelCache', data);
    },
    setSearchPanelActiveFlagCache({ commit }, data) {
        commit('setSearchPanelActiveFlagCache', data);
    },
    setSearchToggleCache({ commit }, data) {
        commit('setSearchToggleCache', data);
    },
    setSearchResultTableCache({ commit }, data) {
        commit('setSearchResultTableCache', data);
    },
    setSearchResultTableStateCache({ commit }, data) {
        commit('setSearchResultTableStateCache', data);
    },
};
const mutations = {
    setAudienceDetailName(state, data) {
        state.audienceDetailName = data.audienceDetailName;
    },
    setSearchPanelCache(state, data) {
        state.searchPanelCache = data.data;
    },
    setSearchPanelActiveFlagCache(state, data) {
        state.SearchPanelActiveFlagCache = data.showInactive;
    },
    setSearchToggleCache(state, data) {
        state.SearchToggleCache = data.data;
    },
    setSearchResultTableCache(state, data) {
        state.SearchResultTableCache = data.data;
    },
    setSearchResultTableStateCache(state, data) {
        state.SearchResultTableStateCache = data.data;
    }
};
export const manageAudience = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
//# sourceMappingURL=index.js.map